"use client"

import { useMemo, useState } from "react"
import { INDIVIDUAL_ENTRIES, INDIVIDUAL_STEPS } from "@/lib/breach/directory/individuals"
import { Chips, Contact, NeedsCheck, OfficialLinks, SearchBox } from "./directory-ui"

const AUD = [{ id: "all", label: "Everyone" }, { id: "individual", label: "Individuals" }, { id: "business", label: "Businesses" }] as const
type Aud = (typeof AUD)[number]["id"]

export function IndividualsDirectory() {
  const [q, setQ] = useState("")
  const [aud, setAud] = useState<Aud>("all")
  const list = useMemo(() => {
    const n = q.trim().toLowerCase()
    return INDIVIDUAL_ENTRIES.filter((e) => (aud === "all" || e.audience === aud || e.audience === "both") && (!n || `${e.name} ${e.organization} ${e.whatFor} ${e.category}`.toLowerCase().includes(n)))
  }, [q, aud])
  return (
    <div>
      <h2 className="text-2xl font-bold">Steps for an affected person</h2>
      <p className="mt-2 text-sm text-muted-foreground">General information with the official source for each step. Not legal or financial advice.</p>
      <ol className="mt-4 grid gap-3">
        {INDIVIDUAL_STEPS.map((s) => (
          <li key={s.n} className="grid grid-cols-[2rem_1fr] gap-3 rounded-lg border border-border p-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-solid text-sm font-bold text-accent-solid-foreground" aria-hidden>{s.n}</span>
            <div><p>{s.text}</p><a className="mt-1 inline-block text-sm underline" href={s.sourceUrl} target="_blank" rel="noopener nofollow">Official source</a></div>
          </li>
        ))}
      </ol>
      <h2 className="mt-10 text-2xl font-bold">Official resources</h2>
      <p className="mt-2 text-sm text-muted-foreground">If you are a business notifying people, point them here.</p>
      <div className="mt-4"><SearchBox value={q} onChange={setQ} placeholder="Search (for example credit freeze, tax, ransomware)" count={list.length} total={INDIVIDUAL_ENTRIES.length} /></div>
      <Chips options={[...AUD]} value={aud} onChange={setAud} label="Who it is for" />
      <ul className="mt-6 grid gap-4">
        {list.map((e) => (
          <li key={e.id} id={e.id} className="scroll-mt-6 rounded-lg border border-border p-4">
            <div className="flex flex-wrap items-baseline justify-between gap-2"><h3 className="text-lg font-semibold">{e.name}</h3><span className="text-xs text-muted-foreground">{e.organization}</span></div>
            <p className="mt-1 text-sm text-muted-foreground">{e.whatFor}</p>
            <OfficialLinks links={e.urls} />
            <Contact phone={e.phone} />
            {e.costNote && <p className="mt-1 text-xs text-muted-foreground">{e.costNote}</p>}
            <NeedsCheck show={e.needsCheck} />
          </li>
        ))}
      </ul>
    </div>
  )
}
